export default "__VITE_ASSET__wXwLMqeT__"